module.exports = __webpack_public_path__ + "static/assets/16592de47fe4f105fd5d1ba0a892e875.png";